import { useState } from 'react';
import { MessageCircle, X, Send } from 'lucide-react';

export default function FloatingContact() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed bottom-24 right-8 w-14 h-14 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 z-40 animate-bounce"
        aria-label="Chat with us"
      >
        {isOpen ? (
          <X className="w-6 h-6 text-white" />
        ) : (
          <MessageCircle className="w-6 h-6 text-white" />
        )}
      </button>

      {isOpen && (
        <div className="fixed bottom-40 right-8 w-80 bg-white rounded-2xl shadow-2xl z-40 overflow-hidden">
          <div className="bg-gradient-to-r from-blue-600 to-cyan-500 p-4">
            <h3 className="text-white font-bold text-lg">Chat with us</h3>
            <p className="text-blue-100 text-sm">We're here to help!</p>
          </div>

          <div className="p-6 space-y-4 max-h-96 overflow-y-auto">
            <div className="bg-gray-100 rounded-lg p-3">
              <p className="text-sm text-gray-700">
                Hello! How can we help you today?
              </p>
              <p className="text-xs text-gray-500 mt-1">Just now</p>
            </div>

            <div className="space-y-3">
              <button
                onClick={() => {
                  setIsOpen(false);
                  document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full text-left p-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
              >
                <p className="text-sm font-medium text-gray-900">Explore our services</p>
              </button>

              <button
                onClick={() => {
                  setIsOpen(false);
                  document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="w-full text-left p-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
              >
                <p className="text-sm font-medium text-gray-900">Request a quote</p>
              </button>

              <a
                href="https://wa.me/918904160504"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full text-left p-3 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
              >
                <p className="text-sm font-medium text-gray-900">Chat on WhatsApp</p>
              </a>
            </div>
          </div>

          <div className="p-4 border-t border-gray-200">
            <div className="flex space-x-2">
              <input
                type="text"
                placeholder="Type your message..."
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
              <button className="w-10 h-10 bg-gradient-to-br from-blue-600 to-cyan-500 rounded-lg flex items-center justify-center">
                <Send className="w-5 h-5 text-white" />
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
